import React from "react";
import { useIntl } from 'umi';

import styles from './index.scss';

const LoadingFailed = (props) =>{
    const {formatMessage } = useIntl()
    const {failedMsg=formatMessage({ id: 'common_loading_failed'})} = props;
    return <div className={styles.loadingFailedBox}>{failedMsg}</div>
}
export default LoadingFailed;